import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LanguageComponent } from './components/language/language.component';
import { FormComponent } from './components/form/form.component';
import { VerificationComponent } from './components/verification/verification.component';
import { MobileVerificationComponent } from './components/mobile-verification/mobile-verification.component';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { SummarizeComponent } from './components/summarize/summarize.component';
import { FormValidationGuard } from './guards/form-validation/form-validation.guard';
import {
  ConfirmationRouteName,
  CongratulationsRouteName,
  FinalizeRouteName,
  RepatriateRouteName,
  ShortMessageSystemRouteName,
  StartRouteName,
  StepsRouteName,
  VerificationRouteName,
} from './models/constants';
import { CongratulationsComponent } from './components/congratulations/congratulations.component';
import { RepatriateComponent } from './components/repatriate/repatriate.component';
import { SmsValidationComponent } from './components/sms-validation/sms-validation.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';

const routes: Routes = [
  {
    path: ':language',
    component: LanguageComponent,
    canActivateChild: [FormValidationGuard],
    children: [
      { path: '', redirectTo: StartRouteName, pathMatch: 'full' },
      { path: StartRouteName, component: IntroductionComponent },
      { path: StepsRouteName, component: FormComponent },
      { path: VerificationRouteName, component: VerificationComponent },
      {
        path: FinalizeRouteName,
        component: SummarizeComponent,
      },
      {
        path: CongratulationsRouteName,
        component: CongratulationsComponent,
      },
      {
        path: RepatriateRouteName,
        component: RepatriateComponent,
      },
      {
        path: 'mobile-verification/:code',
        component: MobileVerificationComponent,
      },
      {
        path: ShortMessageSystemRouteName,
        component: SmsValidationComponent,
      },
      {
        path: ConfirmationRouteName,
        component: ConfirmationComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
